import { Component, inject } from '@angular/core';
import { SpeedDialButton } from '../../../models/generated/ziroModels';

import { ZiroFormAbstractDirective } from '../../../../forms/ziro-form-abstract.directive';
import { ZiroFormStateService } from '../../../../forms/ziro-form-state.service';
import { PhoneButtonsService } from '../../shared/phone-buttons.service';
import { ZiroFormsValidationState } from '../../../../forms/ziro-forms-models';
import { Observable } from 'rxjs';
import { ZiroFormsModule } from '../../../../forms/ziro-forms.module';

enum SpeedDialLabelTitle {
  LABEL_TITLE = 'tkey;pages.details.phoneSettings.button.speedDial.label',
  NUMBER_TITLE = 'tkey;pages.details.phoneSettings.button.speedDial.number',
  TYPE_TITLE = 'tkey;pages.details.phoneSettings.button.type',
}

@Component({
  selector: 'ziro-phone-buttons-speed-dial',
  templateUrl: './phone-buttons-speed-dial.component.html',
  styleUrls: ['./phone-buttons-form.scss'],
  imports: [ZiroFormsModule],
})
export class PhoneButtonsSpeedDialComponent extends ZiroFormAbstractDirective<SpeedDialButton> {
  protected _ziroFormStateService: ZiroFormStateService;
  private phoneButtonsService = inject(PhoneButtonsService);

  fieldGroups = {
    textInputs: ['value', 'label'],
  };

  formConfig = {
    fields: {
      value: {
        label: SpeedDialLabelTitle.NUMBER_TITLE,
        dataAutomation: 'phone-button-speed-dial-number',
        required: false,
        validation: [
          {
            validator: (val: string) =>
              this.phoneButtonsService.validSpeedDialExtensionLength(val)
                ? ZiroFormsValidationState.VALID
                : ZiroFormsValidationState.INVALID,
            message: {
              content: 'tkey;validators.global.error.maxlength',
              params: {
                maxlength: 50,
              },
            },
          },
          {
            validator: (val: string) =>
              this.phoneButtonsService.validSpeedDialExtensionPattern(val)
                ? ZiroFormsValidationState.VALID
                : ZiroFormsValidationState.INVALID,
            message: 'tkey;validators.global.error.invalid_number.pattern',
          },
        ],
      },
      label: {
        label: SpeedDialLabelTitle.LABEL_TITLE,
        dataAutomation: 'phone-button-speed-dial-label',
        required: false,
        validation: [
          {
            validator: (val: string) =>
              this.phoneButtonsService.validLabelLength(val)
                ? ZiroFormsValidationState.VALID
                : ZiroFormsValidationState.INVALID,
            message: {
              content: 'tkey;validators.global.error.maxlength',
              params: {
                maxlength: 30,
              },
            },
          },
          {
            validator: (val: string) =>
              this.phoneButtonsService.validSpeedDialLabelPattern(val)
                ? ZiroFormsValidationState.VALID
                : ZiroFormsValidationState.INVALID,
            message: 'tkey;validators.global.error.pattern',
          },
        ],
      },
    },
    options: {
      columnClasses: {
        label: 'col-3 text-lg-end',
        input: 'col-9',
      },
    },
  };

  submit(): Observable<any> {
    return this.parentSubmit$();
  }
}
